/* eslint-disable react/no-danger */
import cs from 'classnames';
import Image from 'next/image';
import type { FC } from 'react';
import { useState } from 'react';
import { Box, Button, Container } from '@/DesignSystem/Component';
import { htmlStringNormalizer } from '@/Module/Core/Helper';
import { useAppSelector } from '@/Module/Store/Hook';
import { selectedTeacherSelector } from '@/Module/Teacher/Store/Selector/selectedTeacherSelector';
const TeacherDetailDescription: FC = () => {
  const teacher = useAppSelector(selectedTeacherSelector)!;
  const teacherTitle = `${teacher?.person?.name ?? ''}  ${teacher?.person?.family ?? ''}`;
  const [showAll, setShowAll] = useState(false);
  const clickHandler = () => {
    setShowAll(!showAll);
  };
  return <div className="border-b-4 border-l-8 border-r-4 border-t-8 border-blueFive bg-orangeThree   " data-sentry-component="TeacherDetailDescription" data-sentry-source-file="TeacherDetailDescription.tsx">
      <Container className="  bg-right-top bg-no-repeat sm:bg-teacher-description sm:bg-right-bottom" data-sentry-element="Container" data-sentry-source-file="TeacherDetailDescription.tsx">
        <div className="flex flex-col items-center sm:flex-row ">
          <div className=" order-1 flex w-full justify-center  bg-teacher-details-mobile bg-cover bg-bottom sm:w-fit  sm:min-w-[300px] sm:max-w-[50%] sm:justify-items-start sm:self-end sm:bg-none md:mr-[3%] md:min-w-[400px] ">
            <Image src={teacher.coverUrl} alt={teacherTitle} className="mt-16 sm:mt-0 md:min-w-[400px] " width={400} height={455} data-sentry-element="Image" data-sentry-source-file="TeacherDetailDescription.tsx" />
          </div>
          <Box className="order-0 z-10   mr-4 mt-8 flex h-fit max-w-[500px] flex-col p-4 sm:order-10 sm:my-12 sm:p-8 lg:mr-[10%]  xl:mr-[20%]" data-sentry-element="Box" data-sentry-source-file="TeacherDetailDescription.tsx">
            <h1 className="my-2 text-4xl font-bold text-orangeFive drop-shadow-titleText sm:my-4 ">{teacherTitle}</h1>

            <span className="mb-4 flex text-orangeFive">سامانه آموزش مجازی آی‌نو</span>

            {teacher.description && <div className={cs('lg:leading-loose prose max-w-full text-orangeSix lg:prose-xl mb-3 lg:mb-6 overflow-hidden ', showAll ? 'line-clamp-none' : 'line-clamp-6')} dangerouslySetInnerHTML={{
            __html: htmlStringNormalizer(teacher?.description)
          }} />}

            <Button className="self-center" variant="shadow" color="orange" radius="circle" size="large" onClick={clickHandler} bold data-sentry-element="Button" data-sentry-source-file="TeacherDetailDescription.tsx">
              {showAll ? 'نمایش کمتر' : 'نمایش بیشتر'}
            </Button>
          </Box>
        </div>
      </Container>
    </div>;
};
export default TeacherDetailDescription;